"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RAD2DEG = exports.DEG2RAD = exports.Epsilon = exports.ToLinearSpace = exports.ToGammaSpace = exports.Space = exports.Orientation = void 0;
/**
 * Defines potential orientation for back face culling
 * @public
 */
var Orientation;
(function (Orientation) {
    /**
     * Clockwise
     */
    Orientation[Orientation["CW"] = 0] = "CW";
    /** Counter clockwise */
    Orientation[Orientation["CCW"] = 1] = "CCW";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
/**
 * Defines supported spaces
 * @public
 */
var Space;
(function (Space) {
    /** Local (object) space */
    Space[Space["LOCAL"] = 0] = "LOCAL";
    /** World space */
    Space[Space["WORLD"] = 1] = "WORLD";
    /** Bone space */
    Space[Space["BONE"] = 2] = "BONE";
})(Space = exports.Space || (exports.Space = {}));
/**
 * Constant used to convert a value to gamma space
 * @public
 */
exports.ToGammaSpace = 1 / 2.2;
/**
 * Constant used to convert a value to linear space
 * @public
 */
exports.ToLinearSpace = 2.2;
/**
 * Constant used to define the minimal number value in Babylon.js
 * @public
 */
exports.Epsilon = 0.000001;
/**
 * Constant used to convert from Euler degrees to radians
 * @public
 */
exports.DEG2RAD = Math.PI / 180;
/**
 * Constant used to convert from radians to Euler degrees
 * @public
 */
exports.RAD2DEG = 360 / (Math.PI * 2);
//# sourceMappingURL=types.js.map